import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

import { useRedux } from 'util/hook/redux';
import { getToken, removeToken } from 'util/authStorage';
import { wrapAuthFetch } from 'util/api';

export const loadTokenFromCookie = createAction('LOAD_TOKEN_FROM_COOKIE', () => getToken());

const logout = createAction('LOGOUT', () => async () => {
	const { status } = await wrapAuthFetch('auth/logout', {
		method: 'POST',
	});

	if (status !== 200) {
		return {};
	}

	removeToken();
	return {};
});

const reducer = {
	auth: handleActions(
		{
			LOAD_TOKEN_FROM_COOKIE: (state, action) => ({
				...state,
				...action.payload,
			}),
			LOGOUT_FULFILLED: () => ({
				accessToken: '',
				endAt: '',
				expiresIn: '',
				refreshToken: '',
			}),
		},
		{
			accessToken: '',
			endAt: '',
			expiresIn: '',
			refreshToken: '',
		},
	),
};

const selectToken = createSelector(
	state => state.auth.accessToken,
	accessToken => accessToken,
);

export const useToken = () => useRedux(selectToken, { logout });

export default { reducer };
